import { render, staticRenderFns } from "./describeItem.vue?vue&type=template&id=8af22378&scoped=true&"
import script from "./describeItem.vue?vue&type=script&lang=js&"
export * from "./describeItem.vue?vue&type=script&lang=js&"
import style0 from "./describeItem.vue?vue&type=style&index=0&id=8af22378&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af22378",
  null
  
)

export default component.exports